import type { IStackTokens } from "@fluentui/react";
import { Stack } from "@fluentui/react";
import * as React from "react";
import type { ApiResource } from "../../utils/elofleet-repository";
import type { PaginationState } from "../../utils/pagination-state";
import { PaginationButtons } from "../atoms/pagination-buttons";
import css from "./layout-list.scss";
import sizes from "../sizes.scss";

export interface LayoutListProps {
    readonly children: JSX.Element;
    readonly paginationState?: PaginationState<ApiResource>;
    readonly commandBar?: JSX.Element;
    readonly searchField?: JSX.Element;
    readonly title?: string;
    readonly filter?: JSX.Element;
    readonly footer?: JSX.Element;
}

const horizontalGapStackTokens: IStackTokens = {
    childrenGap: sizes.xl,
};

export class LayoutList extends React.Component<LayoutListProps> {
    public render(): JSX.Element {
        return (
            <div className={css.layoutList}>
                {this.props.title ||
                this.props.searchField ||
                this.props.filter ||
                this.props.commandBar ? (
                    <div className={css.layoutList__header}>
                        {this.props.title && (
                            <h3 className={css.layoutList__title}>{this.props.title}</h3>
                        )}
                        {this.props.searchField && (
                            <div className={css.layoutList__searchField}>
                                <Stack.Item align="start">{this.props.searchField}</Stack.Item>
                            </div>
                        )}
                        {this.props.filter && (
                            <div className={css.layoutList__filter}>
                                <Stack
                                    horizontal
                                    verticalAlign="center"
                                    tokens={horizontalGapStackTokens}
                                >
                                    {this.props.filter}
                                </Stack>
                            </div>
                        )}
                        {this.props.commandBar && (
                            <div className={css.layoutList__commandBar}>
                                <Stack.Item align="end">{this.props.commandBar}</Stack.Item>
                            </div>
                        )}
                    </div>
                ) : null}
                <div className={css.layoutList__content}>{this.props.children}</div>
                <div className={css.layoutList__footer}>
                    {this.props.paginationState && (
                        <PaginationButtons paginationState={this.props.paginationState} />
                    )}
                    {this.props.footer}
                </div>
            </div>
        );
    }
}
